module.exports = __webpack_public_path__ + "img/notifications.560acefd.svg";